<template>
  <div class="text">
    <lock-button v-if="showLock" :locked="locked" :field-id="lockingFieldId"
                 :can-change="canChangeLock" @change="lockChanged" />

    <required v-if="required" />
    <label v-if="label" :id="labelId" class="col-form-label" :for="inputId">
      {{ label }}
    </label>
    <div v-if="locked">
      <slot name="readonly-field" />
    </div>
    <div v-else>
      <slot name="editable-field" />
    </div>
  </div>
</template>

<script>
import ajax from '@/helpers/ajax'
import FieldWithLock from '@/mixins/field-with-lock'
import LockButton from '@/components/buttons/lock-button'
import Required from '@/components/required'

export default {
  components: { LockButton, Required },

  mixins: [ FieldWithLock ],

  props: {
    fieldName: {
      type: String,
      required: true
    },
    inputId: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      locked: this.initialLocked
    }
  },

  computed: {
    labelId() {
      return `${this.fieldName}-label`
    },
    lockingFieldId() {
      return `${this.inputId}_locked`
    }
  },

  methods: {
    lockChanged(newLockValue) {
      this.locked = newLockValue

      ajax.put({
        url: this.lockUpdatePath,
        data: {
          lockable_field: `${this.fieldName}_locked`,
          lock_value: this.locked
        },
        errorHandler: () => {
          this.locked = !this.locked
        }
      })
    }
  }
}
</script>
